import axios from 'axios';

export default function auth(state = {}, action) {
  switch (action.type) {
    case 'user_list_SUCCESS':
      return { ...state, data: action.payload.data, error: null }
    case 'user_list_FAIL':
      return { ...state, error: action.payload.error.reponse.data }
    case 'setAuth':
      var data = action.payload;
      axios.defaults.headers.common['Authorization'] = data.token;
      localStorage.user = JSON.stringify(data);
      return {...state, user: data, error: null};
    case 'login_SUCCESS':
      var payload = action.payload;
      var data = payload.data;
      axios.defaults.headers.common['Authorization'] = data.token;
      localStorage.user = JSON.stringify(data);
      return {...state, user: data, error: null};
    case 'login_FAIL':
      delete localStorage.user;
      delete axios.defaults.headers.common['Authorization'];
      return { ...state, user: null, error: action.error.response.data};
    case 'token_SUCCESS':
      var payload = action.payload;
      var data = payload.data;
      axios.defaults.headers.common['Authorization'] = data.token;
      localStorage.user = JSON.stringify(data);
      return {...state, user: data, tryGetToken: true, error: null};
    case 'token_FAIL':
      delete localStorage.user;
      delete axios.defaults.headers.common['Authorization'];
      return { ...state, user: null, tryGetToken: true };
    default:
      if (state.user == undefined) {
        var user = localStorage.user ? JSON.parse(localStorage.user) : null;
        if (user) {
          axios.defaults.headers.common['Authorization'] = user.token;
        }
        return {...state, user: user};
      }
      else {
        return state;
      }
  }
}


// WEBPACK FOOTER //
// ./client/reducers/auth.js